module.exports = __webpack_public_path__ + "img/ontest.3e4a8105.svg";